export default {
    methods: {
      convertDateToString(date) {
        return date.toLocaleDateString("fr-CA").substring(0, 10)
      },
      parseLocalDate(dateString) {
        const [year, month, day] = dateString.split('-').map(Number)
        return new Date(year, month - 1, day)
      },
      addMonths(date, months) {
        const newDate = new Date(date)
        newDate.setMonth(newDate.getMonth() + months)
        return newDate
      },
      addYears(date, years) {
        const newDate = new Date(date)
        newDate.setFullYear(newDate.getFullYear() + years)
        return newDate
      },
      addDays(date, days) {
        const newDate = new Date(date)
        newDate.setDate(newDate.getDate() + days)
        return newDate
      }
    }
  }